// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/DustinSans-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/DustinSans-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/DustinSans-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/DustinSans-LightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/DustinSans-RegularItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/DustinSans-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Dustin Sans";
  font-style: normal;
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: "Dustin Sans";
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@font-face {
  font-family: "Dustin Sans";
  font-style: normal;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@font-face {
  font-family: "Dustin Sans";
  font-style: italic;
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

@font-face {
  font-family: "Dustin Sans";
  font-style: italic;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

@font-face {
  font-family: "Dustin Sans";
  font-style: italic;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

html,
body {
  font-family: "Dustin Sans", sans-serif;
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@skyportal/ui-kit/dist/fonts.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,4CAA0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,4CAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,4CAAgD;AAClD;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,4CAAkD;AACpD;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,4CAA+C;AACjD;;AAEA;;EAEE,sCAAsC;EACtC,eAAe;AACjB","sourcesContent":["@font-face {\n  font-family: \"Dustin Sans\";\n  font-style: normal;\n  font-weight: 300;\n  src: url(\"./fonts/DustinSans-Light.woff2\");\n}\n\n@font-face {\n  font-family: \"Dustin Sans\";\n  font-style: normal;\n  font-weight: 400;\n  src: url(\"./fonts/DustinSans-Regular.woff2\");\n}\n\n@font-face {\n  font-family: \"Dustin Sans\";\n  font-style: normal;\n  font-weight: 700;\n  src: url(\"./fonts/DustinSans-Bold.woff2\");\n}\n\n@font-face {\n  font-family: \"Dustin Sans\";\n  font-style: italic;\n  font-weight: 300;\n  src: url(\"./fonts/DustinSans-LightItalic.woff2\");\n}\n\n@font-face {\n  font-family: \"Dustin Sans\";\n  font-style: italic;\n  font-weight: 400;\n  src: url(\"./fonts/DustinSans-RegularItalic.woff2\");\n}\n\n@font-face {\n  font-family: \"Dustin Sans\";\n  font-style: italic;\n  font-weight: 700;\n  src: url(\"./fonts/DustinSans-BoldItalic.woff2\");\n}\n\nhtml,\nbody {\n  font-family: \"Dustin Sans\", sans-serif;\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
